var defaults = {
  validateOn: 'blur',
  formatOn: 'blur',
  ignoreControlKeys: true,
  useThousandsSeparator: false,
  minimumLength: 2
};

function clearFormat(value) {
  return value.replace(/[\.\-]/g, "");
}

function format(value, useThousandsSeparator) {
  var rutAndDv = splitRutAndDv(value);
  var cRut = rutAndDv[0]; var cDv = rutAndDv[1];
  if (!(cRut && cDv)) { return cRut || value; }
  var rutF = "";
  var thousandsSeparator = useThousandsSeparator ? "." : "";
  while (cRut.length > 3) {
    rutF = thousandsSeparator + cRut.substr(cRut.length - 3) + rutF;
    cRut = cRut.substring(0, cRut.length - 3);
  }
  return cRut + rutF + "-" + cDv;
}

function isControlKey(e) {
  return e.type && e.type.match(/^key(up|down|press)/) &&
    (
      e.keyCode === 8 || // del
      e.keyCode === 16 || // shift
      e.keyCode === 17 || // ctrl
      e.keyCode === 18 || // alt
      e.keyCode === 20 || // caps lock
      e.keyCode === 27 || // esc
      e.keyCode === 37 || // arrow
      e.keyCode === 38 || // arrow
      e.keyCode === 39 || // arrow
      e.keyCode === 40 || // arrow
      e.keyCode === 91    // command
    );
}

function isValidRut(rut, options) {
  if (typeof (rut) !== 'string') { return false; }
  var cRut = clearFormat(rut);
  if (typeof options.minimumLength === 'boolean') {
    if (options.minimumLength && cRut.length < defaults.minimumLength) {
      return false;
    }
  } else {
    var minLength = parseInt(options.minimumLength, 10);
    if (cRut.length < minLength) {
      return false;
    }
  }
  var cDv = cRut.charAt(cRut.length - 1).toUpperCase();
  var nRut = parseInt(cRut.substr(0, cRut.length - 1));
  if (isNaN(nRut)) { return false; }
  return computeDv(nRut).toString().toUpperCase() === cDv;
}

function computeDv(rut) {
  var suma = 0;
  var mul = 2;
  if (typeof (rut) !== 'number') { return; }
  rut = rut.toString();
  for (var i = rut.length - 1; i >= 0; i--) {
    suma = suma + rut.charAt(i) * mul;
    mul = (mul + 1) % 8 || 2;
  }
  switch (suma % 11) {
    case 1: return 'k';
    case 0: return 0;
    default: return 11 - (suma % 11);
  }
}

function formatInput(input, useThousandsSeparator) {
  input.value = format(input.value, useThousandsSeparator);
}

function validateInput(input) {
  if (isValidRut(input.value, input.opts)) {
    var rd = splitRutAndDv(input.value);
    if (typeof rd === 'undefined') return;
    var event = new Event('rutValido');
    input.dispatchEvent(event);
  } else {
    var event = new Event('rutInvalido');
    input.dispatchEvent(event);
  }
}

function splitRutAndDv(rut) {
  var cValue = clearFormat(rut);
  if (cValue.length === 0) { return [null, null]; }
  if (cValue.length === 1) { return [cValue, null]; }
  var cDv = cValue.charAt(cValue.length - 1);
  var cRut = cValue.substring(0, cValue.length - 1);
  return [cRut, cDv];
}

// Métodos públicos
var methods = {
  init: function (options) {
    if (this.length > 1) {
      /* Valida multiples objetos a la vez */
      for (var i = 0; i < this.length; i++) {
        this[i].opts = Object.assign({}, defaults, options);
      }
    } else {
      var that = this;
      that.opts = Object.assign({}, defaults, options);

      that.opts.formatOn && that.addEventListener(that.opts.formatOn, function (e) {
        if (that.opts.ignoreControlKeys && isControlKey(e)) { return; }
        formatInput(that, that.opts.useThousandsSeparator);
      });

      document.body.addEventListener('keydown', function (e) {
        var x = e.which || e.keycode;
        var len = that.value.replace('-', '').replace('.', '').replace('.', '');
        if (len.length < 9) {
          if ((e.shiftKey && (x >= 48 && x <= 57)) || (e.shiftKey && (x >= 189 && x <= 190)) || (e.shiftKey && x == 109)) {
            return false;
          } else {
            if ((e.shiftKey && x != 75) || (x >= 186 && x <= 222) || (x >= 65 && x <= 74) || (x >= 76 && x <= 90) || x == 111 || x == 191 || x == 188 || x == 192 || x == 106 || x == 109 || x == 107) {
              return false;
            } else {
              return true;
            }
          }
        } else {
          if (x == 8 || x == 46 || (x >= 37 && x <= 40)) {
            return true;
          } else {
            return false;
          }
        }
      });

      that.opts.validateOn && that.addEventListener(that.opts.validateOn, function () {
        validateInput(that);
      });

      return this;
    }
  }
};

HTMLElement.prototype.rut = function (methodOrOptions) {
  if (methods[methodOrOptions]) {
    return methods[methodOrOptions].apply(this, Array.prototype.slice.call(arguments, 1));
  } else if (typeof methodOrOptions === 'object' || !methodOrOptions) {
    return methods.init.apply(this, arguments);
  } else {
    console.error("El método " + methodOrOptions + " no existe en la función 'rut'");
  }
};